export const OPERATING_MODES = ['PDV', 'STANDALONE'];

export const OPERATING_MODE_LABELS = {
  PDV: 'PDV',
  STANDALONE: 'Standalone',
  UNDEFINED: 'Sin definir',
};

export const EMPRESAS = [
  { value: 1, label: 'HiperGas' },
  { value: 2, label: 'NaturalGas' },
];
